const inputFilesLabelNew = {
  text: 'Adjuntar archivos aquí'
};

export default inputFilesLabelNew;
